import { render, staticRenderFns } from "./TermsDetail.vue?vue&type=template&id=50c2ed48&scoped=true"
import script from "./TermsDetail.vue?vue&type=script&lang=js"
export * from "./TermsDetail.vue?vue&type=script&lang=js"
import style0 from "./TermsDetail.vue?vue&type=style&index=0&id=50c2ed48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c2ed48",
  null
  
)

export default component.exports